import * as Sentry from '@sentry/angular';

export function getSentry(): typeof Sentry {
  return Sentry;
}
